/**
 * React context for the signed-in user, who is the same in every silo.
 *
 * The user is `null` when no one is signed in.
 */

import React from 'react';

export type User = {
    id: string;
    name: string;
    picture: string | null;
    email: string | null;
    emailVerified: boolean;
};

export const UserContext = React.createContext<User | null>(null);

export function useUser(): User | null {
    return React.useContext(UserContext);
}
